<template>
  <v-card>
    <v-card-title class="pr-0">
      <h3 class="checkout-h3">Legenda</h3>
      <v-spacer></v-spacer>
      <v-btn class="mr-0" right flat icon @click="closeInfo">
            <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
    <div v-if="pricesSubtitle">
      <v-layout row v-for="(seat, index) in pricesSubtitle" :key="index">
          <div class="icon-img ml-2 mr-3 mb-4"><v-icon small :color="seat.cor ? `${seat.cor}` : '#e0e0e0'">brightness_1</v-icon></div>
          <span class="grey--text">{{seat.price}}</span>
        </v-layout>
      </div>
    <v-layout row v-for="(option, index) in options" :key="index">
      <div class="icon-img ml-2 mr-3 mb-4"><v-img flat :src="option.icon"></v-img></div>
      <span class="grey--text">{{option.text}}</span>
    </v-layout>
    </v-card-text>

    <v-card-title>
      <h3 class="checkout-h3">Assentos especiais*</h3>
      <span class="grey--text">* Pode ser solicitado comprovação no dia do evento.</span>
    </v-card-title>
    <v-card-text>
    <v-layout>
      <div class="icon-img-pcd mr-4 mb-4"><v-img flat :src="pcdLarge.icon"></v-img></div>
      <span class="grey--text">{{pcdLarge.text}}</span>
    </v-layout>
    <v-layout>
      <div class="icon-img ml-2 mr-4 mb-4"><v-img flat :src="pcdSmall.icon"></v-img></div>
      <span class="grey--text ml-3">{{pcdSmall.text}}</span>
    </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            options: [
                {icon: 'https://blueticket-cdn.s3.amazonaws.com/assets/icons/unavaiable_seat.svg', text: 'Indisponível'},
                {icon: 'https://blueticket-cdn.s3.amazonaws.com/assets/icons/selected_seat.svg', text: 'Selecionado'},
                ],
            pcdSmall:  {icon: 'https://blueticket-cdn.s3.amazonaws.com/assets/icons/pcd_small.svg', text: 'Pessoas com Mobilidade Reduzida'},
            pcdLarge:  {icon: 'https://blueticket-cdn.s3.amazonaws.com/assets/icons/pcd_large.svg', text: 'Portador de Cadeira de Rodas'},
            pricesSubtitle: null
        }
    },
    mounted () {
      this.setPriceSubtitle()
    },
    computed: {
      ...mapGetters(['sectorMap', "selectedSector"])
    },
    methods: {
        setPriceSubtitle () {
          let array = []
          this.sectorMap.forEach(seat => {
            if (seat.cor && seat.produto_vinculado && !array.find(a => seat.cor == a.cor) && seat.disponivel) array.push({cor: seat.cor, price: this.rangeByType(this.selectedSector.products.filter(t => seat.produto_vinculado === t.codigo_produto))})
          })
          this.pricesSubtitle = array
        },
        closeInfo() {
            this.$store.commit('SET_SELECTED_INFO', false);
        },
        rangeByType(productTypes) {
          let min = Number.MAX_SAFE_INTEGER;
          let max = Number.MIN_SAFE_INTEGER;

          productTypes.forEach(type => {
            if (!type.encerrado) {
              const value = type.valor + type.valor_conveniencia;
            if (min > value) {
              min = value;
            }

            if (max < value) {
              max = value;
            }
            }

          });

          if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
            max = 0
            min = 0
            return ''
          }
          min = this.$options.filters.currency(min * 100);
          max = this.$options.filters.currency(max * 100);
          return min !== max ? `Disponível - De ${min} a ${max}` : `Disponível - ${min}`;
        },
      }
};
</script>

<style scoped>
.icon-img{
    width: 18px;
    height: 18px;
}
.icon-img-pcd{
    width: 43px;
    height: 18px;
}
</style>
